import React,{useState} from 'react';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import HomeIcon from '@material-ui/icons/Home';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import Button from '@material-ui/core/Button';
import {Styles} from './Styles';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import ModalHead from './ModalHead';
import Tanka from './Tanka';
import {Song} from './Inc';
//import Ajax from './Ajax';

interface Props {
    song: Song,
    userId: string,
    close():void,
    next?(): void,
}

const HaikuShow = (props:Props)=> {
    //Ajax.setUserId(props.userId);
    const classes = Styles.base();
    const [isPlay,setIsPlay] = useState(false);

    const lines:string[] = [props.song.words1,props.song.words2,props.song.words3];
    let text = lines.join(" ")+" #ガンネンタンカ";
    const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fgannen%2F"+props.song.gid+"&text="+encodeURIComponent(text);
    
    const play = ()=>{
        setIsPlay(true);
    }
    const close = ()=>{
        props.close();
    }

    if( isPlay ){
        return (
            <Tanka userId={props.userId} haiku={props.song} close={close}/>
        )
    }

	return (
		<div id="haiku_show">
            <ModalHead close={props.close}/>
            <div className={classes.modalRoot}>
                <div className={classes.panel}>
                    {lines.map((words,index)=>{
                        const key = "choiced"+index;
                        return (
                            <div key={key}>{words}</div>
                        )
                    })}
                </div>
                <div className={classes.upperButtons}>
                    {props.song.userId===props.userId ? (
                    <a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}><Tooltip title="ツイートする"><Button
                        variant="contained"
                        className={classes.tweetButton}
                        color="primary"
                    ><ChatBubbleOutlineIcon style={{marginRight:"0.5em"}}/> tweet</Button></Tooltip></a>
                    ):(
                    <Button variant="contained" color="primary" onClick={play}><PlayArrowIcon/>PLAY</Button>
                    )}
                </div>
                <Tooltip title="タイムラインに戻る"><Fab color="primary" aria-label="Close" size="small" className={classes.fabClose} onClick={props.close}>
                    <HomeIcon/>
                </Fab></Tooltip>
                {props.next &&
                <Tooltip title="もっと作る"><Fab color="secondary" aria-label="Add" className={classes.fabAddHaiku} onClick={props.next}>
                    <AddIcon/>
                </Fab></Tooltip>
                }
            </div>
		</div>
	);
}

export default HaikuShow;
